'use client';

import CookieConsent from 'react-cookie-consent';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import { modalState } from '@/features/privacyPolicy/privacyPolicySlice';
import { giveConsent } from '@/features/cookiesConsent/cookiesConsentSlice';

export default function CookieConsentBanner() {
  const dispatch = useAppDispatch();
  const currentModalState = useAppSelector(
    (state) => state.privacyPolicyModal.privacyPolicyModalOpen
  );

  const handleModalState = () => {
    dispatch(modalState(!currentModalState));
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={() => dispatch(giveConsent(true))}
      onDecline={() => dispatch(giveConsent(false))}
      style={{
        background: '#1a2d3e',
        color: '#fff',
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
      cookieName="arcanis-capital-cookies-consent"
      expires={180}
      buttonStyle={{
        background: '#bf9d3b',
        color: '#fff',
        fontSize: '14px',
        borderRadius: '8px',
      }}
      declineButtonStyle={{
        background: '#4d6071',
        color: '#fff',
        fontSize: '14px',
        borderRadius: '8px',
      }}
    >
      This website uses cookies to enhance the user experience. Please read our{' '}
      <span onClick={handleModalState} className="cursor-pointer underline">
        Privacy Policy
      </span>{' '}
      to learn more.
    </CookieConsent>
  );
}
